<template>
  <div :style="{ width: width }">
    <!-- <treeselect 
			v-model="value" 
			:multiple="true" 
			:options="options.map(el => ({
				value: el.branch_id,
				id:el.branch_id, label: el.branch_name_en
			}))"
			:limit="1"
			:limitTex="20"	
			:placeholder="$t('filter_by_branch')"
			@input="input"
    />-->
    <a-select v-model="value" showSearch mode="multiple" class="ts-w-full" :placeholder="placeholder"
      optionFilterProp="children" :loading="loading" :maxTagTextLength="17" :maxTagCount="1" :options="
        options.map(el => ({
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en + ' | ' + el.company.company_name_en
        }))
      " :filterOption="
  (input, option) =>
    option.componentOptions.children[0].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
" @change="changeValue" />
  </div>
</template>

<script>
export default {
  name: 'branchFilter',
  props: {
    isPlaceholder: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '257px'
    }
  },
  data() {
    return {
      value: [],
      options: [],
      loading: false
    }
  },
  created() {
    this.fetchBranch()
  },
  computed: {
    placeholder() {
      return this.$t('all')
    }
  },
  methods: {
    fetchBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssigned')
        .then(response => {
          this.options = response.data
          this.value =
            [this.$store.state.authUser.user.default_branch.branch_id]
            this.$emit('filter', this.value)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeValue() {
      this.$emit('filter', this.value)
    }
  }
}
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
